<template>
    <div class="graybg">
    <!-- hasSidebar  -->
    <div class="header-box">
        <div class="header">
            <div class="logo"></div>
            <div class="nav">
                <ul>
                    <li><a class="current-page" href="./staticHome.html">Home</a></li>
                    <li><a class="nav-linear" href="javascript:void 0">/</a></li>
                    <li><a href="./staticFees.html">Fees</a></li>
                    <li><a class="nav-linear" href="javascript:void 0">/</a></li>
                    <li><a href="./staticPolicy.html">Privacy Policy</a></li>
                    <li><a class="nav-linear" href="javascript:void 0">/</a></li>
                    <li><a href="./staticTerms.html">Terms Of Use</a></li>
                    <li><a class="nav-linear" href="javascript:void 0">/</a></li>
                    <li><a href="./staticDownloads.html">Downloads</a></li>
                    <li><a class="nav-linear" href="javascript:void 0">/</a></li>
                    <li><a href="./staticAboutus.html">About Us</a></li>
                    <li><a class="nav-linear" href="javascript:void 0">/</a></li>
                    <li><a href="./staticContact.html">Contact us</a></li>
                </ul>
            </div>
        </div>
    </div>
    <div class="banner">
        <img :src="banner">
    </div>
    <div class="content-section">
        <div class="titleA">
            <h1>Maxus Essential Technical Information Portal</h1>
        </div>
        <div class="content-module mt-20 mb-30">
            This website is aiming at providing essential technical information for vehicle repair and maintenance under Maxus brand.Please read carefully the Privacy Policy and Terms of use before you start downloading.
        </div>
        <!--<div class="static-btn Btn002B60 circle-btn">more >></div>-->
    </div>
    <div class="footer-box">
        <div class="footer">SAIC MAXUS © 2018 沪ICP备12020307号 沪公安网安备31011002000375号</div>
    </div>

    </div>
</template>

<script scoped>
    import banner from 'assets/img/pageImgs/banner@2x.png'
    export default {
        data () {
            return {
                banner: banner
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/pages/staticHome/app.vue